export const init = () => {
  // TRACKER 'MY HISTORY LVP'
  const fwk = CUBE.Analytics;
  const sep = AnalyticsConstants.separatorST;
  const tracker = new AnalyticsTracker(
    AnalyticsConstants.trackers.customer.historyLVP
  );
  const trackerOtherPages = new AnalyticsTracker(
    AnalyticsConstants.trackers.product.lvp
  );

  (() => {
    /**
     * PART 1 - ACCOUNT / MY LVP HISTORY
     * 	- Init actions tracking
     * 	- Init enhanced ecommerce & shopping-tool
     */
    if (!$('#my-history-lvp').length) return;

    // Switch Tracking LVP
    const switchTrackingLVP = new AnalyticsTriggerEvent(
      'switchTrackingLVP',
      tracker.defaultEvent()
    );
    switchTrackingLVP.trigger = 'change';
    switchTrackingLVP.domElement = '#browing-history';
    switchTrackingLVP.getLabel = $elt =>
      `Switch Tracking LVP to ${$elt.is(':checked') ? 'ON' : 'OFF'}`;
    tracker.addEvent(switchTrackingLVP);

    // DELETE ALL LVP
    const deleteAllLVP = new AnalyticsClickEvent(
      'deleteAllLVP',
      tracker.defaultEvent()
    );
    deleteAllLVP.domElement = '.delete-all-lvp';
    deleteAllLVP.options.label = 'Delete All LVP';
    deleteAllLVP.getValue = () => $('.product-list').find('.product').length;
    tracker.addEvent(deleteAllLVP);

    // DELETE 1 LVP
    const deleteOneLVP = new AnalyticsClickEvent(
      'deleteOneLVP',
      tracker.defaultEvent()
    );
    deleteOneLVP.domElement = '.delete-lvp:not(.delete-all-lvp)';
    deleteOneLVP.getLabel = $elt => {
      const $product = $elt.closest('.product');
      const id = $product.data('model-id') || 'id';
      const position =
        $('.product-list')
          .find('.product')
          .index($product) + 1;
      return `Delete One LVP - ${id} - ${position}`;
    };
    tracker.addEvent(deleteOneLVP);

    // TRACK ENHANCED E-COMMERCE
    $('.lvp-product a:not(.delete)').on('click.st', function() {
      // * EC-PRINT is send in 'lvp.js' > loadLVPGrid() *
      const $product = $(this).closest('.lvp-product');
      const model = fwk.perso.lvp.getModel($product);
      // SEND EC-CLICK
      fwk.enhanced.sendClick(model);
      // UPDATE ST
      fwk.shoppingtool.set(
        'account',
        `${model.type + sep}my-history${sep}position${sep}${model.position}`
      );
    });
  })();

  (() => {
    /**
     * PART 2 - OTHER PAGES
     * 	- Init & display link to 'My LVP History'
     * 	- Add eventListener to the link
     */
    if (!$('.plv2-element[data-page="lvp"]').length) return;

    const linkHref = Cube.Utils.localizeUri('/account/myHistoryLVP');
    const linkLabelManage = $('.manage-history-lvp-input').attr('data-message');
    const linkLabelError = $('.delete-history-lvp-input').attr('data-message');
    const generateLinkManageHistory = () =>
      $(
        `<a data-tnr-plv-element-manage-history class="cta-link manage-history-lvp" href="${linkHref}">${linkLabelManage}</a>`
      );
    const generateLinkRemoveHistory = () =>
      $(
        `<a data-tnr-plv-element-remove-history class="cta-link remove-history-lvp" href="#">${linkLabelError}</a>`
      );

    const isAuthent =
      $('.manage-history-lvp-input').attr('data-authent') === 'true';
    let generateLink;

    // Select GenerateLink based on User status (authent or not)
    if (isAuthent) generateLink = generateLinkManageHistory;
    else generateLink = generateLinkRemoveHistory;

    // Place Link above LVP floor :
    let floorLVP;
    if (tc_vars.env_template === 'checkout') {
      // Different location for CART PAGE
      floorLVP = $('.plv2-element[data-page="lvp"]').closest('.cart-list');
      if (!floorLVP.length)
        floorLVP = $('.plv2-element[data-page="lvp"]').closest(
          '.floor-collapse'
        );
      generateLink()
        .appendTo(floorLVP.find('h2'))
        .css('float', 'right');
    } else {
      floorLVP = $('.plv2-element[data-page="lvp"]').closest('.floor');
      if (!floorLVP.length)
        floorLVP = $('.plv2-element[data-page="lvp"]').closest(
          '.floor-collapse'
        );
      generateLink()
        .insertAfter(floorLVP.find('h2'))
        .css('display', 'block')
        .css('text-align', 'right')
        .css('margin-top', '8px')
        .css('margin-right', '8px');
    }

    // If user clicks on 'remove-history-lvp'
    $('.remove-history-lvp').on('click', e => {
      e.preventDefault();

      let $floor; // The LVP floor is different on CartPage
      if (tc_vars.env_template === 'checkout')
        $floor = $('.remove-history-lvp').closest('.cart-list');
      else $floor = $('.remove-history-lvp').closest('section');

      // Call API
      const ajaxDeleteURL = `/${
        tc_vars.env_language
      }/ajax/rest/model/atg/userprofiling/ProfileActor/deleteLVP`;
      $.post(ajaxDeleteURL, { id: 'all' })
        .done(data => {
          // If we get result : Iterates LVP and remove them 1 by 1
          $('.plv2-element[data-page="lvp"]')
            .get()
            .forEach((event, i) => {
              setTimeout(() => {
                const $e = $(event);
                $e.fadeOut(() => {
                  $e.remove();
                  // When all LVP are removed, remove $floor too
                  if ($('.plv2-element[data-page="lvp"]').length === 0)
                    $floor.fadeOut();
                });
              }, i * 100);
            });
        })
        .fail(data => {});

      // Send an event
      const page = {
        homepage: 'HomePage',
        product: 'ProductPage',
        checkout: 'Checkout',
        list: 'ListPage',
        internal_search: 'ListPage',
      };

      new AnalyticsClickEvent('eventLvpRemoveAll', {
        type: 'LvpEvent',
        category: `${page[tc_vars.env_template]} - LVP`,
        action: 'DELETE LVP',
        label: 'Click',
      }).send();
    });

    // CLick Event on 'Manage My History' link :
    const linkManageMyLVP = new AnalyticsClickEvent(
      'linkManageMyLVP',
      tracker.defaultEvent()
    );
    linkManageMyLVP.domElement = '.manage-history-lvp';
    linkManageMyLVP.options.category = 'CustomerAccount';
    linkManageMyLVP.options.action = 'Manage My LVP History';
    linkManageMyLVP.getLabel = () => {
      let label = fwk.utils.toTitleCase(
        CUBE.Analytics.utils.getInfoPage().replace('-', ' ')
      );
      if (label === 'Search Page' && tc_vars.search_products.length === 0) {
        label = 'Search NoResult Page';
      }
      return label;
    };
    linkManageMyLVP.init();

    // CLick Product in Last View Products :
    // const clickOnLastViewedProduct = new AnalyticsClickEvent(
    //   'clickOnLastViewedProduct',
    //   tracker.defaultEvent()
    // );
    // clickOnLastViewedProduct.domElement = '.plv2-element';
    // clickOnLastViewedProduct.options.action = 'Click On A Last Viewed Product';
    // clickOnLastViewedProduct.getLabel = function($elt) {
    //   const brand = $elt
    //     .find('.plv2-el__brand')
    //     .text()
    //     .trim();
    //   const productName = $elt
    //     .find('.plv2-el__name')
    //     .text()
    //     .trim();
    //   const label = `${brand  } - ${  productName}`;
    //   return label;
    // };
    // trackerOtherPages.addEvent(clickOnLastViewedProduct);
  })();

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.add(trackerOtherPages);
  if ($('#my-history-lvp').length) {
    CUBE.Analytics.trackers.init(tracker.params.name);
  }
  if ($('.plv2-element[data-page="lvp"]').length) {
    CUBE.Analytics.trackers.init(trackerOtherPages.params.name);
  }
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/lvp-history-tracker.js